/* ============================================================
   Robotplus by Fluitronic — animaciones de revelado (Motion).
   Custom element <rbp-reveal> usado por cada sección robotplus-*.
   Se auto-inicializa por sección y es compatible con el editor
   de temas (connectedCallback se re-ejecuta al recargar la sección).
   La URL de motion.min.js se pasa en data-motion.
   ============================================================ */
(function () {
  if (window.customElements && customElements.get('rbp-reveal')) return;

  class RbpReveal extends HTMLElement {
    connectedCallback() {
      var root = this;
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-rbp-reveal]'));
      if (!items.length) return;

      // Respetar reduced-motion: no ocultar nada.
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Marcamos que JS va a animar -> el CSS oculta los elementos solo ahora.
      root.classList.add('rbp-anim');

      var reveal = function () {
        root.classList.remove('rbp-anim');
        items.forEach(function (el) { el.style.opacity = ''; el.style.transform = ''; });
      };
      var bailed = false;
      var safety = setTimeout(function () { bailed = true; reveal(); }, 1500);

      var motionUrl = root.dataset.motion;
      if (!motionUrl) { clearTimeout(safety); reveal(); return; }

      import(motionUrl).then(function (m) {
        if (bailed) return;
        clearTimeout(safety);
        var animate = m.animate, inView = m.inView;
        var ease = [0.16, 1, 0.3, 1];
        items.forEach(function (el) {
          inView(el, function () {
            animate(el, { opacity: [0, 1], y: [24, 0] }, { duration: 0.6, ease: ease });
          }, { amount: 0.15 });
        });
      }).catch(function () { clearTimeout(safety); reveal(); });
    }
  }

  if (window.customElements) {
    customElements.define('rbp-reveal', RbpReveal);
  }
})();
